var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowsRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 6.05398H10.2311M13 6.05398V3.33142M13 6.05398L11.2358 4.31829C10.6864 3.77712 9.98927 3.36654 9.18413 3.15441C6.74331 2.51133 4.23445 3.9356 3.58043 6.3356M3 12.6686V9.946M3 9.946L5.76889 9.946M3 9.946L4.7641 11.6817C5.31344 12.2229 6.0106 12.6335 6.81573 12.8456C9.25655 13.4887 11.7654 12.0644 12.4194 9.6644",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgArrowsRefresh;